import {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router';
import {Button, Card, Col, Row, Table, Modal} from "antd";
import {toFSDateTime} from "../../util/timeutils";
import {getPurchaseOrderLineCreation, undoPurchaseOrderLineItem} from "../../api/Api";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const CompletedPOLineItemView = ({item, onApiFail, refresh, onRefresh, props}) => {
    const [ingredients, setIngredients] = useState([]);
    const [undoModalOpen, setUndoModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getPurchaseOrderLineCreation(item.id).then(r => {
            setIngredients(r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            }))
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [onApiFail, item.id]);

    const {completedByUser, completed, hours, quantityCreated, inventoryId, book} = item;

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Used',
            dataIndex: 'quantity',
            key: 'used',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Waste',
            dataIndex: 'waste',
            key: 'waste',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        }
    ]

    const openUndoModal = () => {
        setUndoModalOpen(true);
    }

    const cancelUndoModal = () => {
        setUndoModalOpen(false);
    }

    const onUndoOk = () => {
        const {id: lineId, purchaseId} = item;
        undoPurchaseOrderLineItem(purchaseId, lineId).then(r => {
            if (onRefresh) onRefresh();
            navigate(`/purchaseorder/${purchaseId}`);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
        setUndoModalOpen(false);
    }

    const rowStyle={textAlign: 'left', marginTop: '5px', marginBottom: '5px'}
    let ingredientsContent;
    if (ingredients.length > 0) {
        ingredientsContent = <Table dataSource={ingredients} columns={columns} pagination={false} />
    } else {
        ingredientsContent = <div style={{color: "#108ee9"}}>No Ingredients Reported</div>
    }

    return <div style={{textAlign: 'left'}}>
        <Modal open={undoModalOpen} onOk={onUndoOk} onCancel={cancelUndoModal}>
            This will Undo the data for this Line Item.
            <ul>
                <li>
                    Created products will be removed from inventory.
                </li>
                <li>
                    Ingredients will be returned to inventory
                </li>
                <li>
                    Line Item will be set to "Requested" state
                </li>
            </ul>
        </Modal>
        <Card title={'Requested Product'}>
            <Row style={rowStyle}>
                <Col span={2}><b>Product:</b></Col>
                <Col>{item.quantity} <b>{item.name}</b></Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}><b>Completed By:</b></Col>
                <Col>{completedByUser}</Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}><b>Timestamp:</b></Col>
                <Col>{toFSDateTime(new Date(completed))}</Col>
            </Row>
            <Row style={rowStyle}>
                <Button onClick={openUndoModal}>Undo</Button>
            </Row>
        </Card>
        <Card title={'Ingredients'}>
            {ingredientsContent}
        </Card>
        { (quantityCreated > 0) &&
        <Card title={`Created Inventory`}>
            <Row>
                <Col span={4}><b>Quantity Created:</b></Col>
                <Col>{quantityCreated}</Col>
            </Row>
            {(inventoryId !== null) &&
            <Row>
                <Col span={4}><b>Inventory Created:</b></Col>
                <Col><Link to={`/inventory/${inventoryId}`}>Inventory</Link></Col>
            </Row>
            }
            <Row>
                <Col span={4}><b>Book:</b></Col>
                <Col>{book ? `True`: `False`}</Col>
            </Row>
        </Card>
        }
        <Card title={`Labor`}>
            <Row style={rowStyle}>
                <Col span={2}><b>Hours:</b></Col>
                <Col>{hours}</Col>
            </Row>
        </Card>
    </div>
}